import { render, staticRenderFns } from "./AR-ArchivesRetrieval.vue?vue&type=template&id=118d589c&scoped=true&"
import script from "./AR-ArchivesRetrieval.vue?vue&type=script&lang=js&"
export * from "./AR-ArchivesRetrieval.vue?vue&type=script&lang=js&"
import style0 from "./AR-ArchivesRetrieval.vue?vue&type=style&index=0&id=118d589c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d589c",
  null
  
)

export default component.exports